import SolutionBenefitsI18n from "@/components/landing/shared/SolutionBenefitsI18n";
import { TrendingUp, Users, Clock, PiggyBank } from "lucide-react";
const MarketingBenefitsSection = () => <SolutionBenefitsI18n translationPrefix="marketingSolution" icons={[TrendingUp, Users, Clock, PiggyBank]} />;
export default MarketingBenefitsSection;
